import _ from '../../application/vendor/lodash.custom';

const orderItems = (items, order) => {
  const fields = order.map(currentOrder => currentOrder.field_id);
  const directions = order.map(currentOrder => currentOrder.direction);
  return _.orderBy(items, fields, directions);
};

export default orderItems;
